import React from 'react';

// Site-wide announcement strip, switched on from the admin panel.
const Banner = ({ banner }) => {
  if (!banner || !banner.enabled || !banner.text) return null;

  return (
    <div className="w-full bg-yellow-100 text-yellow-900 text-sm text-center px-4 py-2">
      {banner.text}
      {banner.linkUrl && (
        <>
          {' '}
          <a href={banner.linkUrl} className="font-bold underline" target={banner.linkUrl.startsWith('/') ? undefined : '_blank'} rel="noopener noreferrer">
            {banner.linkText || 'Learn more'}
          </a>
        </>
      )}
    </div>
  );
};

export default Banner;
